module.exports = __webpack_public_path__ + "img/import-bank.51e82849.svg";